import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import {
  resetUsersSearchFilters, updateUsersSearchFilters, getFilters,
  updateSearchtext, toggleSearchUsersIsAllChecks, setUsersSearchChecks
} from 'redux/actions/cv_search'
import { assignationsAct, poolsActions } from 'redux/actions'
import SearchFilters from 'components/SearchFilters'
import { searchFilter, fieldsFilters } from 'constants/conversationSearch'

const SidemenuUsersSearch = () => {
  const dispatch = useDispatch()
  const { brands, delegations, companies, cv_search, pools, user: powerUser } = useSelector(store => store)
  const [conversationFilters, setConversationFilters] = useState(fieldsFilters)
  const [statusIconFilter, setStatusIconFilter] = useState('off')
  const { isAllChecked, checked, filters } = cv_search

  useEffect(() => {
    getFiltersOptions()
  }, [])

  useEffect(() => {
    if (pools.refreshCounter) getFiltersOptions()
    return () => dispatch(poolsActions.resetRefreshCounter())
  }, [pools.refreshCounter])

  useEffect(() => {
    setStatusIconFilter(toggleIconFilter())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  const getFiltersOptions = async () => {
    let filters = { ...conversationFilters }

    try {
      const data = await dispatch(getFilters())

      const assignationsParams = {
        brands: Object.values(data.brands).map((b) => b._id),
        delegations: Object.values(data.delegations).map((d) => d._id),
        dashuser: { company: companies._id }
      }
      let assignations = await dispatch(assignationsAct.getAssignations(assignationsParams))

      filters.assigned.options = Object.values(assignations)
        .filter(u => data.operators.includes(u._id))
        .map(d => ({ value: d._id, label: d.email }))

      filters.providers.options = data.providers.map(provider => ({
        value: provider,
        label: I18n.t(`channels_${provider}`)
      }))

      filters.states.options = data.states.map(state => ({
        value: state,
        label: I18n.t(`states_${state}`)
      }))

      filters.labels.options = data.categories.map(category => ({
        value: category._id,
        label: category.name
      }))

      filters.folders.options = data.lists.map(list => ({
        value: list._id,
        label: list.name
      }))
    } catch (error) {
      filters = { ...conversationFilters }
      console.error(error)
    }

    setConversationFilters(filters)
  }

  const handleOnChange = (value, field) => {
    if (field === 'searchText') {
      dispatch(updateSearchtext(field, value))
    } else {
      dispatch(updateUsersSearchFilters(field, value))
    }
    clearSelection()
  }

  const clearSelection = () => {
    if (checked?.length) dispatch(setUsersSearchChecks([]))
    if (isAllChecked) dispatch(toggleSearchUsersIsAllChecks())
  }

  const toggleIconFilter = () => {
    for (const field of searchFilter ) {
      const typeOfField = typeof filters?.[field]
      if (!['string', 'number', 'boolean'].includes(typeOfField)) {
        if (filters?.[field]?.length !== fieldsFilters[field].default.length) return 'on'
        if (fieldsFilters[field].type === 'date') {
          for (const dateFilter of filters?.[field]) {
            if (dateFilter !== '') return 'on'
          }
        }
      } else {
        if (filters?.[field] !== fieldsFilters[field].default) return 'on'
      }
    }
    return 'off'
  }

  const resetFilters = () => {
    clearSelection()
    dispatch(resetUsersSearchFilters())
    setStatusIconFilter('off')
  }

  return (
    <div className='sidemenu-users-search'>
      <SearchFilters
        brands={brands}
        delegations={delegations}
        fieldsFilter={fieldsFilters}
        searchFilter={searchFilter}
        valueFilters={filters}
        statusIconFilter={statusIconFilter}
        handleOnChange={handleOnChange}
        resetFilters={resetFilters}
        onlyAssignedConversations={powerUser.onlyAssignedConversations}
      />
    </div>
  )
}

export default SidemenuUsersSearch
